import { toast } from 'sonner';
import FloatingActivityIcon from '../../FloatingActivityIcon';
import DraggableIcon from '../../DraggableIcon';
import { buildActivityItem } from '../utils/activityItemBuilder';

export default function PageAnnotationsOverlay({
  pageNum,
  pageRefs,
  chapterAnnotations,
  userAnnotationPositions,
  saveAnnotationPosition,
  setPositionUpdateTrigger,
  positionUpdateTrigger,
  onActivityClick,
  isActivityCompleted,
  activeAnnotationId,
  chapterId,
  activeBookmarks,
  onBookmarkChange,
}) {
  return chapterAnnotations
    .filter(ann => ann.page_number === pageNum)
    .map((ann) => {
      const pageContainer = pageRefs.current[pageNum];
      const pageElement = pageContainer?.querySelector('.react-pdf__Page');

      if (!pageElement) return null;

      const rect = pageElement.getBoundingClientRect();

      const userPosition = userAnnotationPositions[ann.id];
      const positionTop = userPosition?.position_top ?? ann.position_top;
      const positionLeft = userPosition?.position_left ?? ann.position_left;

      const left = (positionLeft / 100) * rect.width;
      const top = (positionTop / 100) * rect.height;
      const activityItem = buildActivityItem(ann);

      const handleAnnotationDragEnd = async (newPositionTop, newPositionLeft) => {
        try {
          await saveAnnotationPosition(ann.id, newPositionTop, newPositionLeft);
          setPositionUpdateTrigger(prev => prev + 1);
        } catch (error) {
          console.error('Error saving annotation position:', error);
          toast.error('Failed to save position');
        }
      };

      const userPositionKey = userPosition ? `${userPosition.position_left}-${userPosition.position_top}` : 'default';

      return (
        <DraggableIcon
          key={`annotation-${ann.id}-${positionUpdateTrigger}-${userPositionKey}`}
          initialLeft={left}
          initialTop={top}
          onDragEnd={handleAnnotationDragEnd}
          onClick={() => {
            if (onActivityClick) {
              onActivityClick(activityItem);
            }
          }}
          pageElement={pageElement}
          disabled={false}
        >
          <FloatingActivityIcon
            item={activityItem}
            isCompleted={isActivityCompleted ? isActivityCompleted(activityItem.id || activityItem.annotation_id) : false}
            activeAnnotationId={activeAnnotationId}
            annotationId={ann.id || ann.annotation_id}
            chapterId={chapterId}
            onClick={() => {
              if (onActivityClick) {
                onActivityClick(activityItem);
              }
            }}
            position={{
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              transition: 'none'
            }}
            isBookmarked={!!activeBookmarks[String(activityItem.id || activityItem.annotation_id)]}
            bookmarkId={activeBookmarks[String(activityItem.id || activityItem.annotation_id)]}
            onBookmarkToggle={(id, active, bookmarkId) => {
              if (onBookmarkChange) {
                onBookmarkChange(id, active, bookmarkId);
              }
            }}
          />
        </DraggableIcon>
      );
    });
}
